const Create = "CREATE_";
const Update = "UPDATE_";
const Delete = "DELETE_";
const ticketChangeResources = [
  {
    tag: "crs/rail-booking/V2/ticket-change-perform/std",
    title: "Standart Değişiklik",
    parameters: ["STD"],
    existsInLoggedInUserResources: false,
  },
  {
    tag: "crs/rail-booking/V2/ticket-change-perform/org",
    title: "Kurum Kaynaklı Değişiklik",
    parameters: ["ORG"],
    existsInLoggedInUserResources: false,
  },
  {
    tag: "crs/rail-booking/V2/ticket-change-perform/dly",
    title: "Tehirli Tren Değişikliği",
    parameters: ["DLY"],
    existsInLoggedInUserResources: false,
  },
  {
    tag: "crs/rail-booking/V2/ticket-change-perform/std",
    title: "İletişim Bilgisi Değişikliği",
    parameters: ["CONTACT"],
    existsInLoggedInUserResources: false,
  },
  ...(__ENVIRONMENT__ === "uat"
    ? [
        {
          tag: "crs/rail-booking/V2/ticket-change-perform/opr",
          title: "Operasyon Tren Değişikliği",
          parameters: ["OPR"],
          existsInLoggedInUserResources: false,
        },
      ]
    : []),
];
const MyPages = {
  YONETICI_ISLEMLERI: "Yönetici İşlemleri",
  // >>>>>>
  //stationStatusListView
  ISTASYON_DURUM_YONETIMI: "İstasyon Durum Yönetimi",
  ESLENIK_ISTASYON_YONETIMI: "Eşlenik İstasyon Yönetimi",
  TRENIM_NEREDE_ISTASYON_YONETIMI: "Trenim Nerede İstasyon Yönetimi",
  //stationTypeListView
  ISTASYON_TIPI_YONETIMI: "İstasyon Tipi Yönetimi",
  //hardwareListView
  DONANIM_YONETIMI: "Donanım Yönetimi",

  UYGULAMA_VERSIYON_YONETIMI: "Uygulama Versiyon Yönetimi",
  //physicalPropertyListView
  ISTASYON_FIZIKSEL_OZELLIK_YONETIMI: "İstasyon Fiziksel Özellik Yönetimi",
  //stationListView
  ISTASYON_YONETIMI: "İstasyon Yönetimi",
  // ---------
  //lineListView
  HAT_YONETIMI: "Hat Yönetimi",
  // ---------
  //orerListView
  ZAMAN_CIZELGESI_YONETIMI: "Zaman Çizelgesi (ORER) Yönetimi",
  // ---------
  NESNE_VAGON_YONETIMI: "Nesne - Vagon Yönetimi",
  //itemListView
  NESNE_YONETIMI: "Nesne Yönetimi",
  //itemGroupListView
  NESNE_GRUP_SABLONU: "Nesne Grup Şablonu",
  // item type list view
  NESNE_TIPI_YONETIMI: "Nesne Tipi Yönetimi",
  // item type list view
  NESNE_GRUP_TIPI_YONETIMI: "Nesne Grup Tipi Yönetimi",
  // item type list view
  NESNE_OZELLIK_YONETIMI: "Nesne Özellik Yönetimi",
  //carListView
  VAGON_TIP_EKLEME: "Vagon Tip Ekleme",
  //seatMapListView
  VAGON_TASARIMI_YONETIMI: "Vagon Tasarımı Yönetimi",
  VAGON_GRUBU_YONETIMI: "Vagon Grubu Yönetimi",
  // ---------
  //seatMapConnectingTemplateListView
  VAGON_AKTARMA_SABLONU: "Vagon Aktarma Şablonu",
  // ---------
  TREN_YONETIMI: "Tren Yönetimi",
  // ---------
  SATIS_ISLEMLERI: "Satış İşlemleri",
  // >>>>>>
  BILET_SATIS: "Bilet Satış",
  // ---------
  FIYATLANDIRMA: "Fiyatlandırma",
  // >>>>>>
  ENVARTER_YONETIMI: "Envanter Yönetimi",
  //priceFamilyListView
  UCRET_AILESI_YONETIMI: "Ücret Ailesi Yönetimi",
  //classListListView
  SINIF_YONETIMI: "Sınıf Yönetimi",
  //ticketClassRulesListView
  BILET_SINIF_KURAL_YONETIMI: "Bilet Sınıf Kural Yönetimi",
  // ---------
  FIYATLANDIRMA_YONETIMI: "Fiyatlandırma Yönetimi",
  // >>>>>>
  //priceListView
  FIYAT_YONETIMI: "Fiyat Yönetimi",
  //additionalServiceListView
  EK_HIZMET_YONETIMI: "Ek Hizmet Yönetimi",
  //additionalServiceListView
  EK_HIZMET_TURU_YONETIMI: "Ek Hizmet Türü Yönetimi",
  //additionalServicePricingListView
  EK_HIZMET_FIYAT_YONETIMI: "Ek Hizmet Fiyat Yönetimi",
  //specialServiceListView
  OZEL_SERVIS_HIZMET_YONETIMI: "Özel Hizmet Yonetimi",
  // resource group
  YETKI_GRUP_YONETIMI: "Yetki Grup Yönetimi",
  // specialServiceRequestCategory
  OZEL_SERVIS_ISTEK_KATEGORISI: "Özel Hizmet Türü",
  // role
  ROLE: "Rol Yönetimi",
  // main unit
  ANA_BIRIM_YONETIMI: "Ana Birim Yönetimi",
  // passenger type
  PASSENGER_TYPE: "Tarife Yönetimi",
  // connecting Train
  TREN_SETI_YONETIMI: "Tren Seti Yönetimi",
  //TRAIN_CONNECTING
  CONNECTING_TRAIN: "Aktarmalı Tren Yonetimi",
  // segmentListView
  SEGMENT_YONETIMI: "Segment Yönetimi",
  // time schedule
  ZAMAN_TARIFE_YONETIMI: "Zaman Tarife Yönetimi",
  //zoneListView
  ZONE_YONETIMI: "Zone Yönetimi",
  //zoneBasedPriceListView
  ZONE_BAZLI_FIYAT_YONETIMI: "Zone Bazlı Fiyat Yönetimi",
  //KilometricBasedPricingView
  KILOMETRIK_BAZLI_FIYAT_YONETIMI: "Kilometrik Fiyat Yönetimi",
  //additionalServiceKilometricBasedPricingView
  EK_HIZMET_KILOMETRIK_BAZLI_FIYAT_YONETIMI: "Ek Hizmet Kilometrik Fiyat Yönetimi",
  //ssrKilometricBasedPricingView
  SSR_KILOMETRIK_BAZLI_FIYAT_YONETIMI: "Özel Hizmet Kilometrik Fiyat Yönetimi",
  //parkourBasedPriceListView
  PARKUR_BAZLI_FIYAT_YONETIMI: "Parkur Bazlı Fiyat Yönetimi",
  //additionalServiceParkourBasedPriceListView
  EK_HIZMET_PARKUR_BAZLI_FIYAT_YONETIMI: "Ek Hizmet Parkur Bazlı Fiyat Yönetimi",
  //ssrParkourBasedPricingView
  SSR_PARKUR_BAZLI_FIYAT_YONETIMI: "Özel Hizmet Parkur Bazlı Fiyat Yönetimi",
  //passengerTypeListView
  TARIFE_YONETIMI: "Tarife Yönetimi",
  //commissionTableListView
  KOMISYON_TABLOSU_YONETIMI: "Komisyon Tablosu Yönetimi",
  //announcementListView
  DUYURU_YONETIMI: "Duyuru Yönetimi",
  //messageTranslationListView
  HATA_MESAJI_CEVIRI_YONETIMI: "Hata Mesajı Çeviri Yönetimi",
  // agentListView
  ACENTE_YONETIMI: "Acente Yönetimi",
  // AdditionalRevenueDefaultListView
  EK_GELIR_YONETIMI: "Ek Gelir Yönetimi",
  // AdditionalRevenueDefaultListView
  EK_GELIR_GIRISI: "Ek Gelir Girişi",
  //box office list view
  GISE_YONETIMI: "Gişe Yönetimi",
  // kontenjan list view
  KONTENJAN_YONETIMI: "Kontenjan Yönetimi",
  SATIS_KANALI_YONETIMI: "Satış Kanalı Yönetimi",
  // SubscriptionPackageListView
  ABONMANLIK_PAKET_YONETIMI: "Abonmanlık Paket Yönetimi",
  // DiscountPackageListView
  INDIRIM_PAKET_YONETIMI: "İndirim Paket Yönetimi",
  // parameter
  PARAMETRE_YONETIMI: "Parametre Yönetimi",
  TITLE: "Ünvan Yönetimi",
  TRAIN_REGION: "Tren Bölge Yönetimi",
  //notificationListView
  BILDIRIM_PLANLAMA: "Bildirim Planlama",
  // blackListRuleView
  KARA_LISTE_KURAL_YONETIMI: "Kara Liste Kural Yönetimi",
  // InformationListView
  BILGILENDIRME_YONETIMI: "Bilgilendirme Yönetimi",
  DOLULUK_BILGILENDIRMESI: "Doluluk Bilgilendirmesi",
  // HelpMainHeaderListView
  YARDIM_SAYFASI_YONETIMI: "Yardım Sayfası Yönetimi",
  // MilitaryUnitsListView
  ASKERI_BIRLIKLER_YONETIMI: "Askeri Birlikler Yönetimi",
  //trainSetMappingListView
  TREN_SETI_AKTARMA_SABLONU: "Tren Seti Aktarma Şablonu",
  //connectedTrainDiscountListView
  AKTARMALI_TREN_INDIRIMI_YONETIMI: "Aktarmalı Tren İndirimi Yönetimi",
  //bulkTicketing
  TOPLU_BILETLEME: "Toplu Biletleme",
  //evaluationListView
  KULLANICI_DEGERLENDIRMELERI: "Kullanıcı Değerlendirmeleri",
  INTERRAIL_EURAIL_ISLEMLERI: "İnterrail/Eurail İşlemleri",
  // menüleri obje içerisinde dön start
  // ! NOT: newItem veya changedItem true ise diğer false olması yada tersi !

  BIRIM_PERSONEL_YONETIMI_MENU: {
    name: "Birim Personel",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Ana Birim Yönetimi",
        route: "/ana-birim-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/birim-personel-yonetimi-menu/ana-birim-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Yetki Grup Yönetimi",
        route: "/yetki-grup-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/birim-personel-yonetimi-menu/yetki-grup-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Rol Yönetimi",
        route: "/rol-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/birim-personel-yonetimi-menu/rol-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kullanıcı Listeleme",
        route: "/kullanici-listeleme",
        children: [],
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/birim-personel-yonetimi-menu/kullanici-listeleme/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kullanıcı Tanımlama",
        route: "/kullanici-tanimlama",
        children: [],
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/birim-personel-yonetimi-menu/kullanici-tanimlama/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Ünvan Yönetimi",
        route: "/unvan-yonetimi",
        children: [],
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/birim-personel-yonetimi-menu/unvan-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Birim Ağacı",
        route: "/birim-agaci",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/birim-personel-yonetimi-menu/birim-agaci/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },
  YONETICI_ISLEMLERI_MENU: {
    name: "Yönetici İşlemleri",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "İstasyon Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "İstasyon Durum Yönetimi",
            route: "/istasyon-durum-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-durum-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "İstasyon Tipi Yönetimi",
            route: "/istasyon-tipi-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-tipi-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Donanım Yönetimi",
            route: "/donanim-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/donanim-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "İstasyon Fiziksel Özellik Yönetimi",
            route: "/istasyon-fiziksel-ozellik-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-fiziksel-ozellik-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Eşlenik İstasyon Yönetimi",
            route: "/eslenik-istasyon-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/eslenik-istasyon-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Trenim Nerede İstasyon Yönetimi",
            route: "/trenim-nerede-istasyon-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/trenim-nerede-istasyon-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "İstasyon Yönetimi",
            route: "/istasyon-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/istasyon-yonetimi-sub-menu/istasyon-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Hat Yönetimi",
        route: "/hat-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/hat-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Zaman Çizelgesi (ORER) Yönetimi",
        route: "/zaman-cizelgesi-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/zaman-cizelgesi-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Nesne - Vagon Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Nesne Yönetimi",
            route: "/nesne-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Nesne Grup Şablonu",
            route: "/nesne-grup-sablonu",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-grup-sablonu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Vagon Tipi Tanımlama",
            route: "/vagon-tipi-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-tipi-tanimlama/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Vagon Tasarımı Yönetimi",
            route: "/vagon-tasarimi-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-tasarimi-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Vagon Grubu Yönetimi",
            route: "/vagon-grubu-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-grubu-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Vagon Aktarma Şablonu",
            route: "/vagon-aktarma-sablonu",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/vagon-aktarma-sablonu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Nesne Özellik Yönetimi",
            route: "/nesne-ozellik-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-ozellik-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Nesne Tipi Yönetimi",
            route: "/nesne-tipi-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-tipi-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Nesne Grup Tipi Yönetimi",
            route: "/nesne-grup-tipi-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/nesne-grup-tipi-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Seti Aktarma Şablonu",
            route: "/tren-seti-aktarma-sablonu",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/nesne-vagon-sub-menu/tren-seti-aktarma-sablonu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Tren Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Tren Yönetimi",
            route: "/tren-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/tren-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Seti Yönetimi",
            route: "/tren-seti-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/tren-seti-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Aktarmalı Tren Yönetimi",
            route: "/aktarmali-tren-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/aktarmali-tren-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Bölge Yönetimi",
            route: "/tren-bolge-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/tren-bolge-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Aktarmalı Tren İndirimi Yönetimi",
            route: "/aktarmali-tren-indirimi-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/tren-yonetimi-sub-menu/aktarmali-tren-indirimi-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Duyuru Yönetimi",
        route: "/duyuru-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/duyuru-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Hata Mesajı Çeviri Yönetimi",
        route: "/hata-mesaji-ceviri-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/hata-mesaji-ceviri-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Sefer Yönetimi",
        route: "/sefer-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/sefer-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kontenjan Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Kontenjan Yönetimi",
            route: "/kontenjan-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/kontenjan-yonetimi/kontenjan-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Kontenjan Yönetimi",
            route: "/tren-kontenjan-islemleri",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/kontenjan-yonetimi/tren-kontenjan-islemleri/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Sefer Kontenjan Yönetimi",
            route: "/sefer-kontenjan-islemleri",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/kontenjan-yonetimi/sefer-kontenjan-islemleri/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Bilgilendirme Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Bildirim Planlama",
            route: "/bildirim-planlama",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/bildirim-yonetimi/bildirim-planlama/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Bilgilendirme Yönetimi",
            route: "/bilgilendirme-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/bildirim-yonetimi/bilgilendirme-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Yolcularına Sms Gönder",
            route: "/tren-yolcularina-sms-gonder",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "mc/send-sms/trainandsubscription-passengers/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Doluluk Bilgilendirmesi",
            route: "/doluluk-bilgilendirme-listesi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yonetici-islemleri-menu/bildirim-yonetimi/doluluk-bilgilendirmesi/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Parametre Yönetimi",
        route: "/parametre-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/parametre-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kullanıcı Değerlendirmeleri",
        route: "/kullanici-degerlendirmeleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/kullanici-degerlendirmeleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Yardım Sayfası Yönetimi",
        route: "/yardim-sayfasi-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yonetici-islemleri-menu/yardim-sayfasi-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "İşlem Geçmişi",
        route: "/islem-gecmisi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "mc/intent-history/get",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  SATIS_ISLEMLERI_MENU: {
    name: "Satış İşlemleri",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Bilet Satış",
        route: "/satis-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/satis-islemleri-menu/satis-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Toplu Biletleme",
        route: "/toplu-biletleme",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/satis-islemleri-menu/toplu-biletleme/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },
  FIYATLANDIRMA_MENU: {
    name: "Fiyatlandırma",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Envanter Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Ücret Ailesi Yönetimi",
            route: "/ucret-ailesi-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/fiyatlandirma-menu/envarter-yonetimi-sub-menu/ucret-ailesi-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Sınıf Yönetimi",
            route: "/sinif-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/fiyatlandirma-menu/envarter-yonetimi-sub-menu/sinif-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Bilet Sınıf Kural Yönetimi",
            route: "/bilet-sinif-kural-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/fiyatlandirma-menu/envarter-yonetimi-sub-menu/bilet-sinif-kural-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Fiyatlandırma Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Ek Hizmet Yönetimi",
            existsInLoggedInUserResources: false,
            children: [
              {
                name: "Ek Hizmet Türü Yönetimi",
                route: "/ek-hizmet-turu-yonetimi",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-turu-yonetimi/show-page",
                existsInLoggedInUserResources: false,
              },
              {
                name: "Ek Hizmet Yönetimi",
                route: "/ek-hizmet-yonetimi",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-yonetimi/show-page",
                existsInLoggedInUserResources: false,
              },

              {
                name: "Ek Hizmet Kilometre Bazlı Fiyatlandırma Yönetimi",
                route: "/ek-hizmet-kilometre-bazli-fiyatlandirma-tanimlama",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-kilometre-bazli-fiyatlandirma-tanimlama/show-page",
                existsInLoggedInUserResources: false,
              },
              {
                name: "Ek Hizmet Parkur Bazlı Fiyatlandırma Yönetimi",
                route: "/ek-hizmet-parkur-bazli-fiyatlandirma-tanimlama",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ek-hizmet-parkur-bazli-fiyatlandirma-tanimlama/show-page",
                existsInLoggedInUserResources: false,
              },
            ],
          },
          {
            name: "Tarife Yönetimi",
            route: "/tarife-yonetimi",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/tarife-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Parkur Bazlı Fiyatlandırma Yönetimi",
            route: "/parkur-bazli-fiyatlandirma-tanimlama",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/parkur-bazli-fiyatlandirma-tanimlama/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Kilometrik Bazlı Fiyatlandırma Yönetimi",
            route: "/kilometre-bazli-fiyatlandirma-tanimlama",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/kilometre-bazli-fiyatlandirma-tanimlama/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Özel Hizmet Yönetimi",
            existsInLoggedInUserResources: false,
            children: [
              {
                name: "Özel Hizmet Türü Yönetimi",
                route: "/ozel-servis-istek-kategorisi",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ozel-servis-istegi-kategorisi/show-page",
                existsInLoggedInUserResources: false,
              },
              {
                name: "Özel Hizmet Yönetimi",
                route: "/ozel-servis-hizmeti-yonetimi",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag:
                  "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ozel-servis-istegi-kategorisi/ozel-servis-hizmeti-yonetimi/show-page",
                existsInLoggedInUserResources: false,
              },
              {
                name: "Özel Hizmet Kilometre Bazlı Fiyatlandırma Yönetimi",
                route: "/ssr-kilometre-bazli-fiyatlandirma-tanimlama",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ssr-kilometre-bazli-fiyatlandirma-tanimlama/show-page",
                existsInLoggedInUserResources: false,
              },
              {
                name: "Özel Hizmet Parkur Bazlı Fiyatlandırma Yönetimi",
                route: "/ssr-parkur-bazli-fiyatlandirma-tanimlama",
                newItem: false,
                changedItem: false,
                favoriteItem: false,
                pagePermissionTag: "b2b/fiyatlandirma-menu/fiyatlandirma-yonetimi-sub-menu/ssr-parkur-bazli-fiyatlandirma-tanimlama/show-page",
                existsInLoggedInUserResources: false,
              },
            ],
          },
        ],
      },
      // fiyatlandırma yönetimi end
    ],
  },
  GISE_YONETIMI_MENU: {
    name: "Gişe Yönetimi",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Gişe Yönetimi",
        route: "/gise-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/gise-yonetimi-menu/gise-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      // Hesap durumu görüntüleme start
      {
        name: "Hesap Durumu Görüntüleme",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Hesap Kapatma Onay",
            route: "/hesap-kapatma-onay",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/gise-yonetimi-menu/hesap-durumu-goruntuleme-sub-menu/hesap-kapatma-onay/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Personel Hesap Kapatma",
            route: "/personel-hesap-kapatma",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/gise-yonetimi-menu/hesap-durumu-goruntuleme-sub-menu/personel-hesap-kapatma/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      // Hesap durumu görüntüleme end
      {
        name: "Kky Hesap Aktarımı",
        route: "/kky-hesap-aktarimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/gise-yonetimi-menu/kky-hesap-aktarimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kullanıcı Hesap Verilerini Sorgulama",
        route: "/kullanici-hesap-verilerini-listeleme",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/gise-yonetimi-menu/kullanici-hesap-verilerini-listeleme/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },
  ACENTE_ISLEMLERI_MENU: {
    name: "Acente İşlemleri",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Acente Yönetimi",
        route: "/acente-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Ödeme",
        route: "/acente-odeme-hesap-kapama-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-odeme-hesap-kapama-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Hesap Dönemi",
        route: "/acente-hesap-donemi-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-hesap-donemi-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Toplu Hesap Kapatma",
        route: "/acente-toplu-hesap-kapatma-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-toplu-hesap-kapatma-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Satış Raporları",
        route: "/acente-satis-raporlari",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-satis-raporlari/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Dönem Sonu Raporlama İşlemleri",
        route: "/acente-donem-sonu-raporlama-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-donem-sonu-raporlama-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Hesap Dönemi (V2)",
        route: "/acente-hesap-donemi-islemleri-v2",
        children: [],
        newItem: true,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-hesap-donemi-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Satış Raporları (V2)",
        route: "/acente-satis-raporlari-v2",
        children: [],
        newItem: true,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-satis-raporlari/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Acente Dönem Sonu Raporlama (V2)",
        route: "/acente-donem-sonu-raporlama-islemleri-v2",
        children: [],
        newItem: true,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/acente-islemleri-menu/acente-donem-sonu-raporlama-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  YOLCU_ISLEMLERI_MENU: {
    existsInLoggedInUserResources: false,
    name: "Yolcu İşlemleri",
    children: [
      {
        name: "Sefer Danışma",
        route: "/sefer-danisma",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/satis-islemleri-menu/sefer-danisma/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Bilet İşlemleri",
        route: "/bilet-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yolcu-islemleri-menu/bilet-islemleri/show-page",
        existsInLoggedInUserResources: false,
        inPageResources: [
          {
            correlationKey: "ticket-mutate-transactions",
            groups: [
              {
                correlationKey: "ticket-cancel",
                title: "İPTAL/İADE",
                resources: [
                  {
                    tag: "crs/rail-booking/V2/ticket-cancellation-perform/std",
                    title: "Standart İade",
                    parameters: ["STD"],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "crs/rail-booking/V2/ticket-cancellation-perform/err",
                    title: "Hatalı İşlem (Kesintisiz) İade",
                    parameters: ["ERR"],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "crs/rail-booking/V2/ticket-cancellation-perform/dly_no_penalty",
                    title: "Tehirli Tren (Kesintisiz) İade",
                    parameters: ["DLY_NO_PENALTY"],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "crs/rail-booking/V2/ticket-cancellation-perform/dly_penalty",
                    title: "Tehirli Tren (Kesintili) İade",
                    parameters: ["DLY_PENALTY"],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
              {
                correlationKey: "ticket-change",
                title: "DEĞİŞİKLİK",
                resources: ticketChangeResources,
              },
              {
                correlationKey: "open-ticket",
                title: "AÇIK BİLET",
                resources: [
                  {
                    tag: "crs/open-tickets/post",
                    title: "Açık Bilete Çevirme",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
              {
                correlationKey: "mco",
                title: "NAKİT İADE KUPONU",
                resources: [
                  {
                    tag: "crs/rail-booking/V2/ticket-cancellation/mco",
                    title: "Nakit İade Kuponu Otomatik Öde",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "crs/mcos/pay-back",
                    title: "Nakit İade Kuponu Öde",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
              {
                correlationKey: "postponement-compensation",
                title: "TEHİR TAZMİNATI",
                resources: [
                  {
                    tag: "crs/rail-booking/V2/postponement-compensation/pay",
                    title: "Tehir Tazminatı Ödeme",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
            ],
          },
          {
            correlationKey: "ticket-notification-file-export-transactions",
            groups: [
              {
                correlationKey: "ticket-notification",
                title: "BİLDİRİM İŞLEMLERİ",
                resources: [
                  {
                    tag: "no-controller/yolcu-islemleri-menu/bilet-islemleri/notification-transactions/send-sms",
                    title: "Sms Gönder",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "no-controller/yolcu-islemleri-menu/bilet-islemleri/notification-transactions/send-e-mail",
                    title: "E-posta Gönder",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
              {
                correlationKey: "ticket-file-export",
                title: "DOSYA İŞLEMLERİ",
                resources: [
                  {
                    tag: "no-controller/yolcu-islemleri-menu/bilet-islemleri/file-export-transactions/excel-export",
                    title: "Excele Aktar",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "tms/pdf/getMultiplePdf",
                    title: "Bilet PDF Yazdır",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "tms/pdf/generatePDF",
                    title: "Biniş Kartı Yazdır",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
            ],
          },
          {
            correlationKey: "reservation-transactions",
            groups: [
              {
                correlationKey: "reservation",
                title: "REZERVASYON",
                resources: [
                  {
                    tag: "crs/rail-booking/V2/reservation-cancellation",
                    title: "Rezervasyon İptal",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "crs/rail-booking/V2/pre-reservation-cancellation",
                    title: "Ödeme Ekranından Koltuk Seçimine Geri Dönüş",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "crs/rail-booking/V2/extend-reservation-exact",
                    title: "Rezervasyon Uzatma Yetkisi",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "crs/rail-booking/V2/extend-reservation",
                    title: "Rezervasyon Oluşturma Yetkisi",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
            ],
          },
          {
            correlationKey: "ticket-search-transactions",
            groups: [
              {
                correlationKey: "by-reservation",
                title: "REZERVASYON BİLGİLERİ İLE ARAMA",
                resources: [
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/reservation/mco",
                    title: "Kupon No",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/reservation/open-ticket-number",
                    title: "Açık Bilet No",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/reservation/ticket-number",
                    title: "Bilet No",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/reservation/locator",
                    title: "PNR No, Rezervasyon No",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
              {
                correlationKey: "by-pax-info",
                title: "YOLCU BİLGİLERİ İLE ARAMA",
                resources: [
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/pax-info/phone-number",
                    title: "Telefon Numarası",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/pax-info/name-surname",
                    title: "Ad Soyad",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/pax-info/e-mail",
                    title: "E-posta",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                  {
                    tag: "in-controller/yolcu-islemleri-menu/bilet-islemleri/search/by/pax-info/identity-number",
                    title: "T.C. Kimlik No",
                    parameters: [],
                    existsInLoggedInUserResources: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Üye Kara Liste Yönetimi",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Üye Kara Liste Yönetimi",
            route: "/uye-kara-liste-yonetimi",
            children: [],
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/yolcu-islemleri-menu/kara-liste-kural-yonetimi-sub-menu/uye-kara-liste-yonetimi/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Müşteri Yönetimi",
        route: "/musteri-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yolcu-islemleri-menu/musteri-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Müşteri Tanımlama",
        route: "/musteri-tanimlama",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yolcu-islemleri-menu/musteri-tanimlama/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kurum Kaynaklı Iade",
        route: "/kurum-kaynakli-iade",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/yolcu-islemleri-menu/kurum-kaynakli-iade/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  PAKET_ISLEMLERI_MENU: {
    name: "Paket İşlemleri",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Abonmanlık Paket Yönetimi",
        route: "/abonmanlik-paket-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/paket-islemleri-menu/abonmanlik-yonetimi-sub-menu/abonmanlik-paket-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "İndirim Paket Yönetimi",
        route: "/indirim-paket-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/paket-islemleri-menu/indirim-paket-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Paket İşlemleri",
        route: "/paket-satis",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/paket-islemleri-menu/abonmanlik-yonetimi-sub-menu/paket-satis/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  ASKERI_ISLEMLER_MENU: {
    name: "Askeri İşlemler",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Askeri Birlik Yönetimi",
        route: "/askeri-birlik-yonetimi",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/askeri-islemler-menu/askeri-birlik-yonetimi/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Muhtıra İşlemleri",
        route: "/muhtira-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/askeri-islemler-menu/muhtira-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Muhtıra Görüntüleme İndirme",
        route: "/muhtira-goruntuleme-indirme",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/askeri-islemler-menu/muhtira-goruntuleme-indirme/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  RAPORLAR_MENU: {
    name: "Raporlar",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Tren Kullanım Raporları",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Tren Bazında Kullanım Verisi",
            route: "/rapor-sayfasi/tren-bazinda-kullanim-verisi",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 6,
            pagePermissionTag: "b2b/raporlar/tren-bazinda-kullanim-verisi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Trenlerin Vagon Tipleri Bazında Kullanım Verileri",
            route: "/rapor-sayfasi/trenlerin-vagon-tipleri-bazinda-kullanim-verileri",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 9,
            pagePermissionTag: "b2b/raporlar/trenlerin-vagon-tipleri-bazinda-kullanim-verileri/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tarife ve Satış Kanalı Bazında Kullanım Verileri",
            route: "/rapor-sayfasi/tarife-ve-satis-kanali-bazinda-kullanim-verileri",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 5,
            pagePermissionTag: "b2b/raporlar/tarife-ve-satis-kanali-bazinda-kullanim-verileri/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tarife Bazında Kullanım Verisi",
            route: "/rapor-sayfasi/tarife-bazinda-kullanim-verisi",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 4,
            pagePermissionTag: "b2b/raporlar/tarife-bazinda-kullanim-verisi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tarife , Tren - Bilet Çıkış - Varış ve Satış Kanalı Bazında Kullanım Verileri",
            route: "/rapor-sayfasi/tarife-tren-bilet-cikis-varis-ve-satis-kanali-bazinda-kullanim-verileri",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 7,
            pagePermissionTag: "b2b/raporlar/tarife-tren-bilet-cikis-varis-ve-varis-ve-satis-kanali-bazinda-kullanim-verileri/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Seferlerin Tren - Km Bazında Vagon Tipleri Doluluk Oranları",
            route: "/rapor-sayfasi/seferlerin-tren-km-bazinda-vagon-tipleri-doluluk-oranlari",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 3,
            pagePermissionTag: "b2b/raporlar/seferlerin-tren-km-bazinda-vagon-tipleri-doluluk-oranlari/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Satış Kanalı Bazında Kullanım Verisi",
            route: "/rapor-sayfasi/satis-kanali-bazinda-kullanim-verisi",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 1,
            pagePermissionTag: "b2b/raporlar/satis-kanali-bazinda-kullanim-verisi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Bilet Çıkış - Varış ve Tren Bazında Kullanım Verisi",
            route: "/rapor-sayfasi/bilet-cikis-varis-ve-tren-bazinda-kullanim-verisi",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 2,
            pagePermissionTag: "b2b/raporlar/bilet-cikis-varis-ve-tren-bazinda-kullanim-verisi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Bazında Tren - KM Doluluk Verisi",
            route: "/rapor-sayfasi/tren-bazinda-tren-km-doluluk-verisi",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 8,
            pagePermissionTag: "b2b/raporlar/tren-bazinda-tren-km-doluluk-verisi/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Bazında Bagaj ve Fark Biletleri Kullanım Verileri",
            route: "/rapor-sayfasi/tren-bazinda-bagaj-ve-fark-biletleri-kullanim-verileri",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 25,
            pagePermissionTag: "b2b/raporlar/tren-bazinda-bagaj-ve-fark-biletleri-kullanim-verileri/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "YHT Performans Raporu",
            route: "/rapor-sayfasi/yht-performans-raporu",
            newItem: true,
            changedItem: false,
            favoriteItem: false,
            reportId: 59,
            pagePermissionTag: "b2b/raporlar/yht-performans-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Konvansiyonel Performans Raporu",
            route: "/rapor-sayfasi/konvansiyonel-performans-raporu",
            newItem: true,
            changedItem: false,
            favoriteItem: false,
            reportId: 61,
            pagePermissionTag: "b2b/raporlar/konvansiyonel-performans-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Fiyat Raporları",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Fiyat Karşılaştırma Raporu",
            route: "/rapor-sayfasi/fiyat-karsilastirma-raporu",
            newItem: true,
            changedItem: false,
            favoriteItem: false,
            pagePermissionTag: "b2b/raporlar/fiyat-karsilastirma-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Kondüktör Raporları",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Satış Kondüktör Raporu",
            route: "/rapor-sayfasi/satis-konduktor-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 17,
            pagePermissionTag: "b2b/raporlar/satis-konduktor-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tren Kondüktör Raporu",
            route: "/rapor-sayfasi/tren-konduktor-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 18,
            pagePermissionTag: "b2b/raporlar/tren-konduktor-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Paket İşlem Raporları",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "İndirim İle Yapılan İşlemler Raporu",
            route: "/rapor-sayfasi/indirim-ile-yapilan-islemleri-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 16,
            pagePermissionTag: "b2b/raporlar/indirim-ile-yapilan-islemleri-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Abonmanlık İle Gerçekleşen Bilet İşlemleri Raporu",
            route: "/rapor-sayfasi/abonmanlik-ile-gerceklesen-bilet-islem-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 19,
            pagePermissionTag: "b2b/raporlar/abonmanlik-ile-gerceklesen-bilet-islem-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "İndirim Paket Satış Raporu",
            route: "/rapor-sayfasi/indirim-paket-satis-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 27,
            pagePermissionTag: "b2b/raporlar/indirim-paket-satis-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Abonmanlık Paket Satış Raporu",
            route: "/rapor-sayfasi/abonmanlik-paket-satis-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 28,
            pagePermissionTag: "b2b/raporlar/abonmanlik-paket-satis-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "İndirim İptal İşlemleri Raporu",
            route: "/rapor-sayfasi/indirim-iptal-islemleri-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 36,
            pagePermissionTag: "b2b/raporlar/indirim-iptal-islemleri-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Abonmanlık Paket İptal İşlemleri Raporu",
            route: "/rapor-sayfasi/abonmanlik-paket-iptal-islemleri-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 37,
            pagePermissionTag: "b2b/raporlar/abonmanlik-paket-iptal-islemleri-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Permi kullanım verileri",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Permi Kullanım Raporu",
            route: "/rapor-sayfasi/permi-kullanim-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 21,
            pagePermissionTag: "b2b/raporlar/permi-kullanim-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Permi Satış Raporu",
            route: "/rapor-sayfasi/permi-satis-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 22,
            pagePermissionTag: "b2b/raporlar/permi-satis-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Reddiyat raporları",
        existsInLoggedInUserResources: false,
        children: [
          // {
          //     name: 'Aylık Satış Reddiyat Raporu',
          //     route: '/rapor-sayfasi',
          //     newItem:false,
          //     changedItem:false,
          //     favoriteItem:false,
          //     reportId:23,
          //     pagePermissionTag:'b2b/raporlar/aylik-satis-reddiyat-raporu/show-page',
          //     existsInLoggedInUserResources: false,
          // },
          {
            name: "Detaylı Reddiyat Raporu",
            route: "/rapor-sayfasi/detayli-reddiyat-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 24,
            pagePermissionTag: "b2b/raporlar/detayli-reddiyat-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Kurumdan Kaynaklı İade Raporu",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Kurumdan Kaynaklı İade İşlemleri",
            route: "/rapor-sayfasi/kurumdan-kaynakli-iade-islemleri-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 30,
            pagePermissionTag: "b2b/raporlar/kurumdan-kaynakli-acik-bilet-islemleri-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Tehirli İşlemler",
        existsInLoggedInUserResources: false,
        children: [
          {
            name: "Tehirli Tren Bilet Değişikliği - İadesi Sorgulama",
            route: "/rapor-sayfasi/tehirli-tren-bilet-değisikligi-iadesi-sorgulama-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 33,
            pagePermissionTag: "b2b/raporlar/tehirli-tren-bilet-değisikligi-iadesi-sorgulama-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
          {
            name: "Tehir Tazminatı İşlemleri Raporu",
            route: "/rapor-sayfasi/tehir-tazminat-raporu",
            newItem: false,
            changedItem: false,
            favoriteItem: false,
            reportId: 48,
            pagePermissionTag: "b2b/raporlar/tehir-tazminat-raporu/show-page",
            existsInLoggedInUserResources: false,
          },
        ],
      },
      {
        name: "Yolcu Bilet Rezervasyonlama Sorgulama Raporu",
        route: "/rapor-sayfasi/yolcu-bilet-rezervasyonlama-sorgulama-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 13,
        pagePermissionTag: "b2b/raporlar/yolcu-bilet-rezervasyonlama-sorgulama-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Tarife Bazlı İşlemler Raporu",
        route: "/rapor-sayfasi/tarife-bazli-islemler-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 14,
        pagePermissionTag: "b2b/raporlar/tarife-bazli-islemler-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Açık Bilet İşlemleri Raporu",
        route: "/rapor-sayfasi/acik-bilet-islemleri-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 15,
        pagePermissionTag: "b2b/raporlar/acik-bilet-islemleri-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Sefer Anlık İşlem Raporu",
        route: "/rapor-sayfasi/sefer-anlik-islem-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 20,
        pagePermissionTag: "b2b/raporlar/sefer-anlik-islem-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Pos Satışları Raporu",
        route: "/rapor-sayfasi/pos-satislari-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 26,
        pagePermissionTag: "b2b/raporlar/banka-pos-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Aktarmalı Trenler Raporu",
        route: "/rapor-sayfasi/aktarmali-trenler-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 31,
        pagePermissionTag: "b2b/raporlar/aktarmali-trenler-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Bilet Kontrol Raporu",
        route: "/rapor-sayfasi/bilet-kontrol-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 34,
        pagePermissionTag: "b2b/raporlar/bilet-kontrol-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Sefer Tarihine Göre Yolcu Bilgileri",
        route: "/rapor-sayfasi/sefer-tarihine-gore-yolcu-bilgileri-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 12,
        pagePermissionTag: "b2b/raporlar/sefer-tarihine-gore-yolcu-bilgileri-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Turistik Satış Raporu",
        route: "/rapor-sayfasi/turistik-satis-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 39,
        pagePermissionTag: "b2b/raporlar/turistik-satis-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Aylık Satış Reddiyat Raporu",
        route: "/aylik-satis-reddiyat-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/raporlar/aylik-satis-reddiyat-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Bilet Tipi Bazında Satışlar Raporu",
        route: "/bilet-tipi-bazinda-satis-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 51,
        pagePermissionTag: "b2b/raporlar/bilet-tipi-bazinda-satis-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Tüm İşlemler",
        route: "/rapor-sayfasi/tum-islem-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 41,
        pagePermissionTag: "b2b/raporlar/tum-islem-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Banka İşlem Sorgulama",
        route: "/rapor-sayfasi/banka-islem-sorgulama-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 43,
        pagePermissionTag: "b2b/raporlar/banka-islem-sorgulama-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Müşteri İstatistiki Bilgi Sorgulama raporu",
        route: "/rapor-sayfasi/musteri-istatistiki-bilgi-sorgulama-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 49,
        pagePermissionTag: "b2b/raporlar/musteri-istatistiki-bilgi-sorgulama-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Amir Onay Tarihçe",
        route: "/rapor-sayfasi/amir-onay-tarihce",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 53,
        pagePermissionTag: "b2b/raporlar/amir-onay-tarihce/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kullanıcı Bazlı MRZ İşlemleri Raporu",
        route: "/rapor-sayfasi/kullanici-bazli-mrz-islem-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 55,
        pagePermissionTag: "b2b/raporlar/kullanici-bazli-mrz-islem-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Birim Bazlı MRZ İşlemleri Raporu",
        route: "/rapor-sayfasi/birim-bazli-mrz-islem-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 56,
        pagePermissionTag: "b2b/raporlar/birim-bazli-mrz-islem-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Personel Performans Raporu",
        route: "/rapor-sayfasi/personel-performans-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 54,
        pagePermissionTag: "b2b/raporlar/personel-performans-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kullanıcı Giriş-Çıkış Raporu",
        route: "/rapor-sayfasi/kullanici-giris-cikis-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 57,
        pagePermissionTag: "b2b/raporlar/kullanici-giris-cikis-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Tren Türü Bazlı Satış Verileri raporu",
        route: "/rapor-sayfasi/tren-türü-bazlı-satış-verileri-raporu",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        reportId: 52,
        pagePermissionTag: "b2b/raporlar/tren-türü-bazlı-satış-verileri-raporu/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  INTERRAIL_EURAIL_MENU: {
    name: "İnterrail/Eurail İşlemleri",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "İnterrail/Eurail İşlemleri",
        route: "/interrail-eurail",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/interrail-eurail-menu/interrail-eurail/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  ULUSLARARASI_MAHSUPLASMA_MENU: {
    name: "Uluslararası Mahsuplaşma",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Giden Dekont Üretme",
        route: "/giden-dekont-uretme",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/uluslararasi-mahsuplasma-menu/giden-dekont-uretme/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  KAYIP_ESYA_MENU: {
    name: "Kayıp Eşya",
    existsInLoggedInUserResources: false,
    children: [
      {
        name: "Bulunan Eşya İşlemleri",
        route: "/kayip-esya-personel-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/kayip-esya-menu/personel-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kayıp Eşya Eşleştirme",
        route: "/kayip-esya-yonetici-islemleri",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/kayip-esya-menu/yonetici-islemleri/show-page",
        existsInLoggedInUserResources: false,
      },
      {
        name: "Kategori ve Ayarlar",
        route: "/kayip-esya-ayarlar",
        children: [],
        newItem: false,
        changedItem: false,
        favoriteItem: false,
        pagePermissionTag: "b2b/kayip-esya-menu/ayarlar/show-page",
        existsInLoggedInUserResources: false,
      },
    ],
  },

  // menüleri obje içerisinde dön end
};
const allMenuList = [
  ...MyPages.BIRIM_PERSONEL_YONETIMI_MENU.children,
  ...MyPages.YONETICI_ISLEMLERI_MENU.children,
  ...MyPages.SATIS_ISLEMLERI_MENU.children,
  ...MyPages.RAPORLAR_MENU.children,
  ...MyPages.FIYATLANDIRMA_MENU.children,
  ...MyPages.GISE_YONETIMI_MENU.children,
  ...MyPages.YOLCU_ISLEMLERI_MENU.children,
  ...MyPages.PAKET_ISLEMLERI_MENU.children,
  ...MyPages.ASKERI_ISLEMLER_MENU.children,
  ...MyPages.ACENTE_ISLEMLERI_MENU.children,
  ...MyPages.INTERRAIL_EURAIL_MENU.children,
  ...MyPages.ULUSLARARASI_MAHSUPLASMA_MENU.children,
  ...MyPages.KAYIP_ESYA_MENU.children,
];

const allMenuTree = [
  MyPages.BIRIM_PERSONEL_YONETIMI_MENU,
  MyPages.YONETICI_ISLEMLERI_MENU,
  MyPages.SATIS_ISLEMLERI_MENU,
  MyPages.RAPORLAR_MENU,
  MyPages.FIYATLANDIRMA_MENU,
  MyPages.GISE_YONETIMI_MENU,
  MyPages.YOLCU_ISLEMLERI_MENU,
  MyPages.PAKET_ISLEMLERI_MENU,
  MyPages.ASKERI_ISLEMLER_MENU,
  MyPages.ACENTE_ISLEMLERI_MENU,
  MyPages.INTERRAIL_EURAIL_MENU,
  MyPages.ULUSLARARASI_MAHSUPLASMA_MENU,
  MyPages.KAYIP_ESYA_MENU,
];

const TicketClassRuleTypes = {
  CREATE: Create + "TICKET_CLASS_RULE",
  UPDATE: Update + "TICKET_CLASS_RULE",
  DELETE: Delete + "TICKET_CLASS_RULE",
  REFUND: "REFUND",
  CHANGE: "CHANGE",
  OPEN_TICKET: "OPEN_TICKET",
  RESERVATION: "RESERVATION",
};
export default {
  STATION: Object.freeze({
    CREATE: Create + "STATION",
    UPDATE: Update + "STATION",
    DELETE: Delete + "STATION",
  }),
  STATION_STATUS: Object.freeze({
    CREATE: Create + "STATION_STATUS",
    UPDATE: Update + "STATION_STATUS",
    DELETE: Delete + "STATION_STATUS",
  }),
  STATION_TYPE: Object.freeze({
    CREATE: Create + "STATION_TYPE",
    UPDATE: Update + "STATION_TYPE",
    DELETE: Delete + "STATION_TYPE",
  }),
  EQUIVALENT_STATION: Object.freeze({
    CREATE: Create + "EQUIVALENT_STATION",
    UPDATE: Update + "EQUIVALENT_STATION",
    DELETE: Delete + "EQUIVALENT_STATION",
  }),
  TRAIN_WHERE_STATION: Object.freeze({
    CREATE: Create + "TRAIN_WHERE_STATION",
    UPDATE: Update + "TRAIN_WHERE_STATION",
    DELETE: Delete + "TRAIN_WHERE_STATION",
  }),
  LINE: Object.freeze({
    CREATE: Create + "LINE",
    UPDATE: Update + "LINE",
    DELETE: Delete + "LINE",
  }),
  SEGMENT: Object.freeze({
    CREATE: Create + "SEGMENT",
    UPDATE: Update + "SEGMENT",
    DELETE: Delete + "SEGMENT",
  }),
  ZONE: Object.freeze({
    CREATE: Create + "ZONE",
    UPDATE: Update + "ZONE",
    DELETE: Delete + "ZONE",
  }),
  HARDWARE: Object.freeze({
    CREATE: Create + "HARDWARE",
    UPDATE: Update + "HARDWARE",
    DELETE: Delete + "HARDWARE",
  }),
  PARKOUR_BASED_PRICING: Object.freeze({
    CREATE: Create + "PARKOUR_BASED_PRICING",
    UPDATE: Update + "PARKOUR_BASED_PRICING",
    DELETE: Delete + "PARKOUR_BASED_PRICING",
  }),
  ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING: Object.freeze({
    CREATE: Create + "ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING",
    UPDATE: Update + "ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING",
    DELETE: Delete + "ADDITIONAL_SERVICE_PARKOUR_BASED_PRICING",
  }),
  ORER: Object.freeze({
    CREATE: Create + "ORER",
    UPDATE: Update + "ORER",
    DELETE: Delete + "ORER",
  }),
  TIME_SCHEDULE: Object.freeze({
    CREATE: Create + "TIME_SCHEDULE",
    UPDATE: Update + "TIME_SCHEDULE",
    DELETE: Delete + "TIME_SCHEDULE",
  }),
  PHYSICAL_PROPERTIES: Object.freeze({
    CREATE: Create + "PHYSICAL_PROPERTY",
    UPDATE: Update + "PHYSICAL_PROPERTY",
    DELETE: Delete + "PHYSICAL_PROPERTY",
  }),
  CAR: Object.freeze({
    CREATE: Create + "CAR",
    UPDATE: Update + "CAR",
    DELETE: Delete + "CAR",
  }),
  ITEM: Object.freeze({
    CREATE: Create + "ITEM",
    UPDATE: Update + "ITEM",
    DELETE: Delete + "ITEM",
  }),
  ITEM_GROUP: Object.freeze({
    CREATE: Create + "ITEM_GROUP",
    UPDATE: Update + "ITEM_GROUP",
    DELETE: Delete + "ITEM_GROUP",
  }),
  POSITION_TYPE: Object.freeze({
    CREATE: Create + "POSITION_TYPE",
    UPDATE: Update + "POSITION_TYPE",
    DELETE: Delete + "POSITION_TYPE",
  }),
  SEAT_MAP: Object.freeze({
    CREATE: Create + "SEAT_MAP",
    UPDATE: Update + "SEAT_MAP",
    DELETE: Delete + "SEAT_MAP",
  }),
  UBS: Object.freeze({
    CREATE: Create + "UBS_CAR_TYPE",
    UPDATE: Update + "UBS_CAR_TYPE",
    DELETE: Delete + "UBS_CAR_TYPE",
  }),
  ZONE_BASED_PRICE: Object.freeze({
    CREATE: Create + "ZONE_BASED_PRICING",
    UPDATE: Update + "ZONE_BASED_PRICING",
    DELETE: Delete + "ZONE_BASED_PRICING",
  }),
  CABIN_CLASS: Object.freeze({
    CREATE: Create + "CABIN_CLASS",
    UPDATE: Update + "CABIN_CLASS",
    DELETE: Delete + "CABIN_CLASS",
  }),
  BOOKING_CLASS: Object.freeze({
    CREATE: Create + "BOOKING_CLASS",
    UPDATE: Update + "BOOKING_CLASS",
    DELETE: Delete + "BOOKING_CLASS",
  }),
  UNIT: Object.freeze({
    CREATE: Create + "UNIT",
    UPDATE: Update + "UNIT",
    DELETE: Delete + "UNIT",
  }),
  SUBSCRIPTION: Object.freeze({
    CREATE: Create + "SUBSCRIPTION",
    UPDATE: Update + "SUBSCRIPTION",
    DELETE: Delete + "SUBSCRIPTION",
  }),
  FARE_FAMILY: Object.freeze({
    CREATE: Create + "FARE_FAMILY",
    UPDATE: Update + "FARE_FAMILY",
    DELETE: Delete + "FARE_FAMILY",
  }),
  PRICING: Object.freeze({
    CREATE: Create + "PRICING",
    UPDATE: Update + "PRICING",
    DELETE: Delete + "PRICING",
  }),
  ADDITIONAL_SERVICE: Object.freeze({
    CREATE: Create + "ADDITIONAL_SERVICE",
    UPDATE: Update + "ADDITIONAL_SERVICE",
    DELETE: Delete + "ADDITIONAL_SERVICE",
  }),
  ADDITIONAL_SERVICE_TYPE: Object.freeze({
    CREATE: Create + "ADDITIONAL_SERVICE_TYPE",
    UPDATE: Update + "ADDITIONAL_SERVICE_TYPE",
    DELETE: Delete + "ADDITIONAL_SERVICE_TYPE",
  }),
  ADDITIONAL_SERVICE_PRICING: Object.freeze({
    CREATE: Create + "ADDITIONAL_SERVICE_PRICING",
    UPDATE: Update + "ADDITIONAL_SERVICE_PRICING",
    DELETE: Delete + "ADDITIONAL_SERVICE_PRICING",
  }),
  SPECIAL_SERVICE_REQUEST_CATEGORY: Object.freeze({
    CREATE: Create + "SPECIAL_SERVICE_REQUEST_CATEGORY",
    UPDATE: Update + "SPECIAL_SERVICE_REQUEST_CATEGORY",
    DELETE: Delete + "SPECIAL_SERVICE_REQUEST_CATEGORY",
  }),
  SPECIAL_SERVICE_REQUEST: Object.freeze({
    CREATE: Create + "SPECIAL_SERVICE_REQUEST",
    UPDATE: Update + "SPECIAL_SERVICE_REQUEST",
    DELETE: Delete + "SPECIAL_SERVICE_REQUEST",
  }),
  RESOURCE_GROUP: Object.freeze({
    CREATE: Create + "RESOURCE_GROUP",
    UPDATE: Update + "RESOURCE_GROUP",
    DELETE: Delete + "RESOURCE_GROUP",
  }),
  PASSENGER_TYPE: Object.freeze({
    CREATE: Create + "PASSENGER_TYPE",
    UPDATE: Update + "PASSENGER_TYPE",
    DELETE: Delete + "PASSENGER_TYPE",
  }),
  ROLE: Object.freeze({
    CREATE: Create + "ROLE",
    UPDATE: Update + "ROLE",
    DELETE: Delete + "ROLE",
  }),
  TRAIN_SET: Object.freeze({
    CREATE: Create + "TRAIN_SET",
    UPDATE: Update + "TRAIN_SET",
    DELETE: Delete + "TRAIN_SET",
  }),
  TRAIN: Object.freeze({
    CREATE: Create + "SCHEDULE",
    UPDATE: Update + "SCHEDULE",
    DELETE: Delete + "SCHEDULE",
  }),
  CONNECTING_TRAIN: Object.freeze({
    CREATE: Create + "CONNECTION_SCHEDULE",
    UPDATE: Update + "CONNECTION_SCHEDULE",
    DELETE: Delete + "CONNECTION_SCHEDULE",
  }),
  ANNOUNCEMENT: Object.freeze({
    CREATE: Create + "ANNOUNCEMENT",
    UPDATE: Update + "ANNOUNCEMENT",
    DELETE: Delete + "ANNOUNCEMENT",
  }),
  MESSAGE_TRANSLATION: Object.freeze({
    CREATE: Create + "MESSAGE_TRANSLATION",
    UPDATE: Update + "MESSAGE_TRANSLATION",
    DELETE: Delete + "MESSAGE_TRANSLATION",
  }),
  NOTIFICATION_MANAGEMENT: Object.freeze({
    CREATE: Create + "NOTIFICATION_MANAGEMENT",
    UPDATE: Update + "NOTIFICATION_MANAGEMENT",
    DELETE: Delete + "NOTIFICATION_MANAGEMENT",
  }),
  INFORMATION_MANAGEMENT: Object.freeze({
    CREATE: Create + "INFORMATION_MANAGEMENT",
    UPDATE: Update + "INFORMATION_MANAGEMENT",
    DELETE: Delete + "INFORMATION_MANAGEMENT",
  }),
  MILITARY_UNIT: Object.freeze({
    CREATE: Create + "MILITARY_UNIT",
    UPDATE: Update + "MILITARY_UNIT",
    DELETE: Delete + "MILITARY_UNIT",
  }),
  AGENCY: Object.freeze({
    CREATE: Create + "AGENCY",
    UPDATE: Update + "AGENCY",
    DELETE: Delete + "AGENCY",
  }),
  COMMISSION_PROFILE: Object.freeze({
    CREATE: Create + "COMMISSION_PROFILE",
    UPDATE: Update + "COMMISSION_PROFILE",
    DELETE: Delete + "COMMISSION_PROFILE",
  }),
  BOX_OFFICE: Object.freeze({
    CREATE: Create + "BOX_OFFICE",
    UPDATE: Update + "BOX_OFFICE",
    DELETE: Delete + "BOX_OFFICE",
  }),
  ITEM_PROPERTY: Object.freeze({
    CREATE: Create + "ITEM_PROPERTY",
    UPDATE: Update + "ITEM_PROPERTY",
    DELETE: Delete + "ITEM_PROPERTY",
  }),
  ITEM_TYPE: Object.freeze({
    CREATE: Create + "ITEM_TYPE",
    UPDATE: Update + "ITEM_TYPE",
    DELETE: Delete + "ITEM_TYPE",
  }),
  ITEM_GROUP_TYPE: Object.freeze({
    CREATE: Create + "ITEM_GROUP_TYPE",
    UPDATE: Update + "ITEM_GROUP_TYPE",
    DELETE: Delete + "ITEM_GROUP_TYPE",
  }),
  PRICING_PERIOD: Object.freeze({
    CREATE: Create + "PRICING_PERIOD",
    UPDATE: Update + "PRICING_PERIOD",
    DELETE: Delete + "PRICING_PERIOD",
  }),
  CAR_GROUP: Object.freeze({
    CREATE: Create + "CAR_TYPE",
    UPDATE: Update + "CAR_TYPE",
    DELETE: Delete + "CAR_TYPE",
  }),
  SEAT_MAP_TEMPLATE_MAPPING: Object.freeze({
    CREATE: Create + "SEAT_MAP_TEMPLATE_MAPPING",
    UPDATE: Update + "SEAT_MAP_TEMPLATE_MAPPING",
    DELETE: Delete + "SEAT_MAP_TEMPLATE_MAPPING",
  }),
  QUOTA: Object.freeze({
    CREATE: Create + "QUOTA",
    UPDATE: Update + "QUOTA",
    DELETE: Delete + "QUOTA",
  }),
  SALES_CHANNEL: Object.freeze({
    CREATE: Create + "SALES_CHANNEL",
    UPDATE: Update + "SALES_CHANNEL",
    DELETE: Delete + "SALES_CHANNEL",
  }),
  DISCOUNT_PACKAGE: Object.freeze({
    CREATE: Create + "DISCOUNT_PACKAGE",
    UPDATE: Update + "DISCOUNT_PACKAGE",
    DELETE: Delete + "DISCOUNT_PACKAGE",
  }),
  TITLE: Object.freeze({
    CREATE: Create + "TITLE",
    UPDATE: Update + "TITLE",
    DELETE: Delete + "TITLE",
  }),
  // ! TODO: backend yok değişebilir !
  PARAMETER: Object.freeze({
    CREATE: Create + "PARAMETER",
    UPDATE: Update + "PARAMETER",
    DELETE: Delete + "PARAMETER",
  }),
  TRAIN_SET_MAPPING: Object.freeze({
    CREATE: Create + "TRAIN_SET_MAPPING",
    UPDATE: Update + "TRAIN_SET_MAPPING",
    DELETE: Delete + "TRAIN_SET_MAPPING",
  }),

  TRAIN_REGION: Object.freeze({
    CREATE: Create + "TRAIN_REGION",
    UPDATE: Update + "TRAIN_REGION",
    DELETE: Delete + "TRAIN_REGION",
  }),
  APP_VERSION: Object.freeze({
    CREATE: Create + "APP_VERSION",
    UPDATE: Update + "APP_VERSION",
  }),
  CONNECTED_TRAIN_DISCOUNT: Object.freeze({
    CREATE: Create + "CONNECTED_TRAIN_DISCOUNT",
    UPDATE: Update + "CONNECTED_TRAIN_DISCOUNT",
    DELETE: Delete + "CONNECTED_TRAIN_DISCOUNT",
  }),
  HELP: Object.freeze({
    CREATE: Create + "HELP",
    UPDATE: Update + "HELP",
    DELETE: Delete + "HELP",
  }),
  MyPages,
  TicketClassRuleTypes,
  allMenuList,
  allMenuTree,
};
